// import React, { useState, useEffect } from 'react';
// import { storage, database, auth } from '../firebase';
// import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
// import { ref, push, update, serverTimestamp, onValue, off, remove, get } from 'firebase/database';
// import { onAuthStateChanged } from 'firebase/auth';

// const ProductForm = ({ editingProduct, onSuccess, onCancel }) => {
//   const [formData, setFormData] = useState({
//     productType: '',
//     batchProduct: '',
//     hsnSacCode: '',
//     productName: '',
//     barcodeType: '',
//     barcode: '',
//     group: '',
//     category: '',
//     brand: '',
//     unit: '',
//     style: '',
//     mrp: '',
//     sellingRate: '',
//     purchaseRateExclTax: '',
//     margin: '',
//     discount: '',
//     savings: '',
//     cessTax: '',
//     purchaseTax: '',
//     salesTax: '',
//     costPriceInclTax: '',
//     sellingPriceInclTax: '',
//     wholesaleRate: '',
//     lowStockAlert: '',
//     reorderQty: '',
//     openingStock: '',
//     image: null,
//     labelNo: '',
//     type: '',
//     location: '',
//     designNo: '',
//   });

//   const [imagePreview, setImagePreview] = useState(null);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');
//   const [currentUser, setCurrentUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false);
//   const [newGroup, setNewGroup] = useState('');
//   const [newCategory, setNewCategory] = useState('');
//   const [newBrand, setNewBrand] = useState('');
//   const [newUnit, setNewUnit] = useState('');
//   const [newDesignNo, setNewDesignNo] = useState(''); // Added state for new design number
//   const [showGroupInput, setShowGroupInput] = useState(false);
//   const [showCategoryInput, setShowCategoryInput] = useState(false);
//   const [showBrandInput, setShowBrandInput] = useState(false);
//   const [showUnitInput, setShowUnitInput] = useState(false);
//   const [showDesignNoInput, setShowDesignNoInput] = useState(false); // Added state for design number input
//   const [customUnits, setCustomUnits] = useState([]);
//   const [newCustomUnit, setNewCustomUnit] = useState({ baseUnit: '', conversionRate: '', secondaryUnit: '' });
//   const [showCustomUnitInput, setShowCustomUnitInput] = useState(false);
//   const [groups, setGroups] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [brands, setBrands] = useState([]);
//   const [units, setUnits] = useState([]);
//   const [taxes, setTaxes] = useState([]);
//   const [designNumbers, setDesignNumbers] = useState([]);
//   const [focusedField, setFocusedField] = useState('');

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, '_');
//   };

//   useEffect(() => {
//     if (editingProduct) {
//       setFormData({
//         productType: editingProduct.productType || '',
//         batchProduct: editingProduct.batchProduct || '',
//         hsnSacCode: editingProduct.hsnSacCode || '',
//         productName: editingProduct.productName || '',
//         barcodeType: editingProduct.barcodeType || '',
//         barcode: editingProduct.barcode || '',
//         group: editingProduct.group || '',
//         category: editingProduct.category || '',
//         brand: editingProduct.brand || '',
//         unit: editingProduct.unit || '',
//         style: editingProduct.style || '',
//         mrp: editingProduct.mrp || '',
//         sellingRate: editingProduct.sellingRate || '',
//         purchaseRateExclTax: editingProduct.purchaseRateExclTax || '',
//         margin: editingProduct.margin || '',
//         discount: editingProduct.discount || '',
//         savings: editingProduct.savings || '',
//         cessTax: editingProduct.cessTax || '',
//         purchaseTax: editingProduct.purchaseTax || '',
//         salesTax: editingProduct.salesTax || '',
//         costPriceInclTax: editingProduct.costPriceInclTax || '',
//         sellingPriceInclTax: editingProduct.sellingPriceInclTax || '',
//         wholesaleRate: editingProduct.wholesaleRate || '',
//         lowStockAlert: editingProduct.lowStockAlert || '',
//         reorderQty: editingProduct.reorderQty || '',
//         openingStock: editingProduct.openingStock || '',
//         image: null,
//         labelNo: editingProduct.labelNo || '',
//         type: editingProduct.type || '',
//         location: editingProduct.location || '',
//         designNo: editingProduct.designNo || '',
//       });
//       if (editingProduct.image) {
//         setImagePreview(editingProduct.image);
//       }
//       if (editingProduct.customUnits) {
//         setCustomUnits(
//           Object.entries(editingProduct.customUnits).map(([id, data]) => ({
//             id,
//             ...data,
//           }))
//         );
//       }
//     }
//   }, [editingProduct]);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setCurrentUser(user);
//       } else {
//         setCurrentUser(null);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (!currentUser) {
//       setLoading(false);
//       return;
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email);

//     const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
//     const groupsListener = onValue(groupsRef, (snapshot) => {
//       const groupsData = [];
//       snapshot.forEach((childSnapshot) => {
//         groupsData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val(),
//         });
//       });
//       setGroups(groupsData);
//     });

//     const categoriesRef = ref(database, `users/${encodedEmail}/categories`);
//     const categoriesListener = onValue(categoriesRef, (snapshot) => {
//       const categoriesData = [];
//       snapshot.forEach((childSnapshot) => {
//         categoriesData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val(),
//         });
//       });
//       setCategories(categoriesData);
//     });

//     const brandsRef = ref(database, `users/${encodedEmail}/brands`);
//     const brandsListener = onValue(brandsRef, (snapshot) => {
//       const brandsData = [];
//       snapshot.forEach((childSnapshot) => {
//         brandsData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val(),
//         });
//       });
//       setBrands(brandsData);
//     });

//     const unitsRef = ref(database, `users/${encodedEmail}/units`);
//     const unitsListener = onValue(unitsRef, (snapshot) => {
//       const unitsData = [];
//       snapshot.forEach((childSnapshot) => {
//         unitsData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val(),
//         });
//       });
//       setUnits(unitsData);
//     });

//     const taxesRef = ref(database, `users/${encodedEmail}/gstTaxes`);
//     const taxesListener = onValue(taxesRef, (snapshot) => {
//       const taxesData = [];
//       snapshot.forEach((childSnapshot) => {
//         taxesData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val(),
//         });
//       });
//       setTaxes(taxesData);
//     });

//     const designsRef = ref(database, `users/${encodedEmail}/designNumbers`);
//     const designsListener = onValue(designsRef, (snapshot) => {
//       const designsData = [];
//       snapshot.forEach((childSnapshot) => {
//         designsData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val(),
//         });
//       });
//       setDesignNumbers(designsData);
//       setLoading(false);
//     });

//     return () => {
//       off(groupsRef);
//       off(categoriesRef);
//       off(brandsRef);
//       off(unitsRef);
//       off(taxesRef);
//       off(designsRef);
//     };
//   }, [currentUser]);

//   useEffect(() => {
//     const sellingPrice = parseFloat(formData.sellingRate) || 0;
//     const costPrice = parseFloat(formData.purchaseRateExclTax) || 0;
//     const mrp = parseFloat(formData.mrp) || 0;
//     const purchaseTax = parseFloat(formData.purchaseTax) || 0;
//     const cessTax = parseFloat(formData.cessTax) || 0;
//     const salesTax = parseFloat(formData.salesTax) || 0;

//     let margin = 0;
//     if (sellingPrice > 0) {
//       margin = ((sellingPrice - costPrice) / sellingPrice) * 100;
//     }

//     let discount = 0;
//     if (mrp > 0) {
//       discount = ((mrp - sellingPrice) / mrp) * 100;
//     }

//     const savings = mrp - sellingPrice;

//     const costPriceInclTax = costPrice * (1 + (purchaseTax + cessTax) / 100);

//     const sellingPriceInclTax = sellingPrice * (1 + (salesTax + cessTax) / 100);

//     setFormData((prev) => ({
//       ...prev,
//       margin: isNaN(margin) ? '0.00' : margin.toFixed(2),
//       discount: isNaN(discount) ? '0.00' : discount.toFixed(2),
//       savings: savings > 0 ? savings.toFixed(2) : '0.00',
//       costPriceInclTax: isNaN(costPriceInclTax) ? '0.00' : costPriceInclTax.toFixed(2),
//       sellingPriceInclTax: isNaN(sellingPriceInclTax) ? '0.00' : sellingPriceInclTax.toFixed(2),
//     }));
//   }, [formData.sellingRate, formData.purchaseRateExclTax, formData.mrp, formData.purchaseTax, formData.cessTax, formData.salesTax]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'hsnSacCode' && value && !/^\d*$/.test(value)) {
//       setErrorMessage('HSN/SAC Code must contain only numbers');
//       return;
//     }

//     if (name === 'barcode' && value) {
//       if (!/^\d*$/.test(value)) {
//         setErrorMessage('Barcode must contain only numbers');
//         return;
//       }
//       if (value.length > 13) {
//         setErrorMessage('Barcode cannot exceed 13 digits');
//         return;
//       }
//     }

//     if ((name === 'style' ||  name === 'location') && value && !/^[a-zA-Z\s]*$/.test(value)) {
//       setErrorMessage(`${name.charAt(0).toUpperCase() + name.slice(1)} must contain only alphabets`);
//       return;
//     }

//     if (name === 'labelNo') {
//       if (value && !/^[a-zA-Z0-9\s]*$/.test(value)) {
//         setErrorMessage(`${name.charAt(0).toUpperCase() + name.slice(1)} must contain only alphabets and numbers`);
//         return;
//       }
//     }

//      if (name === 'type') {
//       if (value && !/^[a-zA-Z0-9\s]*$/.test(value)) {
//         setErrorMessage(`${name.charAt(0).toUpperCase() + name.slice(1)} must contain only alphabets and numbers`);
//         return;
//       }
//     }

//     setFormData({ ...formData, [name]: value });
//     setErrorMessage('');
//   };

//   const handleNewItemChange = (e, setValue, type) => {
//     const value = e.target.value;
//     if (type === 'DesignNo' && value && !/^[a-zA-Z0-9\s]*$/.test(value)) {
//       setErrorMessage('Design Number must contain only alphabets and numbers');
//       return;
//     } else if (value && !/^[a-zA-Z\s]*$/.test(value)) {
//       if (type === 'Unit') {
//         setErrorMessage('Enter a valid unit (e.g., ltr, ml, gm, kg, ms). Only letters allowed.');
//       } else {
//         setErrorMessage(`${type} must contain only alphabets`);
//       }
//       return;
//     }
//     setValue(value);
//     setErrorMessage('');
//   };

//   const handleAddItem = async (type, value, setValue, setShowInput, setItems, formField) => {
//     if (!value.trim()) {
//       setErrorMessage(`Please enter a valid ${type}`);
//       return;
//     }
//     if (type === 'DesignNo' && !/^[a-zA-Z0-9\s]*$/.test(value)) {
//       setErrorMessage('Design Number must contain only alphabets and numbers');
//       return;
//     } else if (!/^[a-zA-Z\s]*$/.test(value)) {
//       if (type === 'Unit') {
//         setErrorMessage('Enter a valid unit (e.g., ltr, ml, gm, kg, ms). Only letters allowed.');
//       } else {
//         setErrorMessage(`${type} must contain only alphabets`);
//       }
//       return;
//     }
//     if (!currentUser) {
//       setErrorMessage('You must be logged in to add items');
//       return;
//     }

//     try {
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       const itemRef = ref(database, `users/${encodedEmail}/${type === 'Group' ? 'productGroups' : type === 'DesignNo' ? 'designNumbers' : type.toLowerCase() + 's'}`);

//       const newItemRef = await push(itemRef, { [type === 'DesignNo' ? 'designNo' : 'name']: value.trim() });
//       setItems((prev) => [
//         ...prev,
//         {
//           id: newItemRef.key,
//           [type === 'DesignNo' ? 'designNo' : 'name']: value.trim(),
//         },
//       ]);
//       setFormData((prev) => ({
//         ...prev,
//         [formField]: value.trim(),
//       }));
//       setValue('');
//       setShowInput(false);
//       setSuccessMessage(`${type} added successfully!`);
//     } catch (error) {
//       setErrorMessage(`Error adding ${type}: ${error.message}`);
//     }
//   };

//   const handleAddCustomUnit = async () => {
//     if (!newCustomUnit.baseUnit || !newCustomUnit.conversionRate || !newCustomUnit.secondaryUnit) {
//       setErrorMessage('Please fill in all custom unit fields');
//       return;
//     }
//     if (!currentUser) {
//       setErrorMessage('You must be logged in to add custom units');
//       return;
//     }

//     try {
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       const customUnitsRef = ref(database, `users/${encodedEmail}/customUnits`);
//       const newUnitRef = await push(customUnitsRef, {
//         baseUnit: newCustomUnit.baseUnit,
//         conversionRate: parseFloat(newCustomUnit.conversionRate),
//         secondaryUnit: newCustomUnit.secondaryUnit,
//       });
//       setCustomUnits([
//         ...customUnits,
//         {
//           id: newUnitRef.key,
//           baseUnit: newCustomUnit.baseUnit,
//           conversionRate: parseFloat(newCustomUnit.conversionRate),
//           secondaryUnit: newCustomUnit.secondaryUnit,
//         },
//       ]);
//       setNewCustomUnit({ baseUnit: '', conversionRate: '', secondaryUnit: '' });
//       setShowCustomUnitInput(false);
//       setSuccessMessage('Custom unit added successfully!');
//     } catch (error) {
//       setErrorMessage(`Error adding custom unit: ${error.message}`);
//     }
//   };

//   const handleDeleteCustomUnit = async (id) => {
//     if (!currentUser) {
//       setErrorMessage('You must be logged in to delete custom units');
//       return;
//     }

//     try {
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       const unitRef = ref(database, `users/${encodedEmail}/customUnits/${id}`);
//       await remove(unitRef);
//       setCustomUnits(customUnits.filter((unit) => unit.id !== id));
//       setSuccessMessage('Custom unit deleted successfully!');
//     } catch (error) {
//       setErrorMessage(`Error deleting custom unit: ${error.message}`);
//     }
//   };

//   const getNextProductId = async (encodedEmail) => {
//     const productsRef = ref(database, `users/${encodedEmail}/products`);
//     const snapshot = await get(productsRef);

//     if (!snapshot.exists()) {
//       return 1;
//     }

//     const products = snapshot.val();
//     const ids = Object.keys(products)
//       .map((id) => parseInt(id))
//       .filter((id) => !isNaN(id));

//     if (ids.length === 0) {
//       return 1;
//     }

//     return Math.max(...ids) + 1;
//   };

//   const isFormChanged = () => {
//     if (!editingProduct) return true;
//     return (
//       Object.keys(formData).some((key) => {
//         if (key === 'image') return !!formData.image;
//         return formData[key] !== (editingProduct[key] || '');
//       }) || customUnits.length !== Object.keys(editingProduct.customUnits || {}).length
//     );
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSuccessMessage('');
//     setErrorMessage('');
//     setSubmitting(true);

//     if (!currentUser) {
//       setErrorMessage('You must be logged in to add a product');
//       setSubmitting(false);
//       return;
//     }

//     if (!formData.productType) {
//       setErrorMessage('Please select a Product Type');
//       setSubmitting(false);
//       return;
//     }

//     if (!formData.batchProduct) {
//       setErrorMessage('Please select Batch Product option');
//       setSubmitting(false);
//       return;
//     }

//     try {
//       let imageUrl = editingProduct?.image || '';
//       if (formData.image) {
//         if (formData.image.size > 5 * 1024 * 1024) {
//           setErrorMessage('Image size should be less than 5MB');
//           setSubmitting(false);
//           return;
//         }

//         const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
//         if (!validTypes.includes(formData.image.type)) {
//           setErrorMessage('Please upload a valid image file (JPEG, PNG, or GIF)');
//           setSubmitting(false);
//           return;
//         }

//         const timestamp = new Date().getTime();
//         const filename = `${timestamp}_${formData.image.name}`;
//         const fileRef = storageRef(storage, `products/${filename}`);
//         const uploadResult = await uploadBytes(fileRef, formData.image);
//         imageUrl = await getDownloadURL(uploadResult.ref);
//       }

//       const customUnitsObject = customUnits.reduce((acc, unit) => {
//         acc[unit.id] = {
//           baseUnit: unit.baseUnit,
//           conversionRate: unit.conversionRate,
//           secondaryUnit: unit.secondaryUnit,
//         };
//         return acc;
//       }, {});

//       const productData = {
//         ...formData,
//         image: imageUrl,
//         customUnits: customUnitsObject,
//         createdAt: editingProduct ? editingProduct.createdAt : serverTimestamp(),
//         createdBy: currentUser.email,
//         mrp: parseFloat(formData.mrp) || 0,
//         sellingRate: parseFloat(formData.sellingRate) || 0,
//         purchaseRateExclTax: parseFloat(formData.purchaseRateExclTax) || 0,
//         margin: parseFloat(formData.margin) || 0,
//         discount: parseFloat(formData.discount) || 0,
//         savings: parseFloat(formData.savings) || 0,
//         cessTax: parseFloat(formData.cessTax) || 0,
//         purchaseTax: parseFloat(formData.purchaseTax) || 0,
//         salesTax: parseFloat(formData.salesTax) || 0,
//         costPriceInclTax: parseFloat(formData.costPriceInclTax) || 0,
//         sellingPriceInclTax: parseFloat(formData.sellingPriceInclTax) || 0,
//         wholesaleRate: parseFloat(formData.wholesaleRate) || 0,
//         lowStockAlert: parseInt(formData.lowStockAlert) || 0,
//         reorderQty: parseInt(formData.reorderQty) || 0,
//         openingStock: parseInt(formData.openingStock) || 0,
//         labelNo: formData.labelNo || '',
//         type: formData.type || '',
//         location: formData.location || '',
//         designNo: formData.designNo || '',
//       };

//       delete productData.image;

//       const encodedEmail = encodeEmailForPath(currentUser.email);

//       if (editingProduct) {
//         if (!isFormChanged()) {
//           setErrorMessage('No changes detected.');
//           setSubmitting(false);
//           return;
//         }
//         const productRef = ref(database, `users/${encodedEmail}/products/${editingProduct.id}`);
//         await update(productRef, productData);
//         alert('Product Updated Successfully.');
//         setSuccessMessage('Product Updated Successfully.');
//       } else {
//         const nextId = await getNextProductId(encodedEmail);
//         const productRef = ref(database, `users/${encodedEmail}/products/${nextId}`);
//         await update(productRef, productData);
//         alert('Product added successfully!');
//         setSuccessMessage('Product added successfully!');
//       }

//       resetForm();
//       onSuccess();
//     } catch (error) {
//       console.error('Error adding/updating product:', error);
//       setErrorMessage(`Error: ${error.message}`);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       productType: '',
//       batchProduct: '',
//       hsnSacCode: '',
//       productName: '',
//       barcodeType: '',
//       barcode: '',
//       group: '',
//       category: '',
//       brand: '',
//       unit: '',
//       style: '',
//       mrp: '',
//       sellingRate: '',
//       purchaseRateExclTax: '',
//       margin: '',
//       discount: '',
//       savings: '',
//       cessTax: '',
//       purchaseTax: '',
//       salesTax: '',
//       costPriceInclTax: '',
//       sellingPriceInclTax: '',
//       wholesaleRate: '',
//       lowStockAlert: '',
//       reorderQty: '',
//       openingStock: '',
//       image: null,
//       labelNo: '',
//       type: '',
//       location: '',
//       designNo: '',
//     });
//     setImagePreview(null);
//     setNewGroup('');
//     setNewCategory('');
//     setNewBrand('');
//     setNewUnit('');
//     setNewDesignNo(''); // Reset new design number
//     setShowGroupInput(false);
//     setShowCategoryInput(false);
//     setShowBrandInput(false);
//     setShowUnitInput(false);
//     setShowDesignNoInput(false); // Reset design number input visibility
//     setCustomUnits([]);
//     setNewCustomUnit({ baseUnit: '', conversionRate: '', secondaryUnit: '' });
//     setShowCustomUnitInput(false);
//   };

//   const styles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '2rem auto',
//       padding: '2rem',
//       backgroundColor: '#ffffff',
//       borderRadius: '16px',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//       minHeight: '100vh',
//     },
//     formWrapper: {
//       backgroundColor: '#ffffff',
//       borderRadius: '20px',
//       padding: '2.5rem',
//       border: '1px solid #e2e8f0',
//     },
//     heading: {
//       fontSize: '1.5rem',
//       fontWeight: '700',
//       marginBottom: '2rem',
//       color: '#1f2937',
//       textAlign: 'center',
//     },
//     messageSuccess: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#d1fae5',
//       color: '#065f46',
//       border: '1px solid #a7f3d0',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     messageError: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#fee2e2',
//       color: '#b91c1c',
//       border: '1px solid #fecaca',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     loadingContainer: {
//       textAlign: 'center',
//       padding: '4rem 2rem',
//       color: '#6b7280',
//     },
//     loadingSpinner: {
//       width: '3rem',
//       height: '3rem',
//       border: '4px solid #e5e7eb',
//       borderTop: '4px solid #2563eb',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite',
//       margin: '0 auto 1rem',
//     },
//     formLayout: {
//       display: 'grid',
//       gridTemplateColumns: '1fr',
//       gap: '2rem',
//     },
//     twoColumnLayout: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
//       gap: '2rem',
//     },
//     section: {
//       backgroundColor: '#fff',
//       padding: '1.5rem',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//     },
//     sectionHeading: {
//       fontSize: '1.25rem',
//       fontWeight: '600',
//       marginBottom: '1rem',
//       color: '#1f2937',
//     },
//     inputGroup: {
//       marginBottom: '1rem',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '0.5rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '1rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     requiredAsterisk: {
//       color: '#ef4444',
//       marginLeft: '0.25rem',
//     },
//     input: {
//       display: 'block',
//       width: '100%',
//       padding: '0.3rem 0.5rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '1rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
//       boxSizing: 'border-box',
//     },
//     inputFocused: {
//       borderColor: '#2563eb',
//       boxShadow: '0 0 0 2px rgba(37, 99, 235, 0.1)',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.3rem 0.5rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '1rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '0.8em 0.8em',
//       paddingRight: '1.5rem',
//       boxSizing: 'border-box',
//       transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
//     },
//     selectFocused: {
//       borderColor: '#2563eb',
//       boxShadow: '0 0 0 2px rgba(37, 99, 235, 0.1)',
//     },
//     addButton: {
//       padding: '0.5rem',
//       borderRadius: '6px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '0.875rem',
//       width: '2rem',
//       height: '2rem',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       flexShrink: 0,
//     },
//     gridTwoColumns: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
//       gap: '1rem',
//     },
//     gridThreeColumns: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
//       gap: '1rem',
//     },
//     imageUploadSection: {
//       padding: '1.5rem',
//       border: '2px dashed #d1d5db',
//       borderRadius: '8px',
//       textAlign: 'center',
//       backgroundColor: '#f9fafb',
//     },
//     fileInput: {
//       display: 'none',
//     },
//     fileInputLabel: {
//       display: 'inline-block',
//       padding: '0.3rem 0.8rem',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       borderRadius: '6px',
//       cursor: 'pointer',
//       fontWeight: '500',
//       fontSize: '1rem',
//     },
//     imagePreview: {
//       marginTop: '1rem',
//       width: '120px',
//       height: '120px',
//       objectFit: 'cover',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       marginTop: '1rem',
//       border: '1px solid #e2e8f0',
//     },
//     th: {
//       backgroundColor: '#f3f4f6',
//       padding: '0.5rem',
//       textAlign: 'left',
//       fontWeight: '600',
//       color: '#374151',
//       borderBottom: '1px solid #e2e8f0',
//     },
//     td: {
//       padding: '0.5rem',
//       borderBottom: '1px solid #e2e8f0',
//     },
//     deleteButton: {
//       padding: '0.25rem 0.5rem',
//       backgroundColor: '#ef4444',
//       color: 'white',
//       border: 'none',
//       borderRadius: '4px',
//       cursor: 'pointer',
//     },
//     buttonContainer: {
//       marginTop: '2rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '1rem',
//       paddingTop: '1rem',
//       borderTop: '1px solid #e2e8f0',
//     },
//     button: {
//       padding: '0.3rem 1rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '1rem',
//       cursor: 'pointer',
//       border: 'none',
//       transition: 'all 0.2s ease',
//     },
//     submitButton: {
//       backgroundColor: '#10b981',
//       color: 'white',
//     },
//     cancelButton: {
//       backgroundColor: '#ef4444',
//       color: 'white',
//     },
//     flexRow: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     readOnlyInput: {
//       backgroundColor: '#f3f4f6',
//       color: '#6b7280',
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.formWrapper}>
//         <h1 style={styles.heading}>🛍️ {editingProduct ? 'Edit Product' : 'Add New Product'}</h1>

//         {successMessage && (
//           <div style={styles.messageSuccess}>
//             <span>✅</span>
//             {successMessage}
//           </div>
//         )}

//         {errorMessage && (
//           <div style={styles.messageError}>
//             <span>❌</span>
//             {errorMessage}
//           </div>
//         )}

//         {loading ? (
//           <div style={styles.loadingContainer}>
//             <div style={styles.loadingSpinner}></div>
//             <p>Loading form data...</p>
//           </div>
//         ) : (
//           <form onSubmit={handleSubmit}>
//             <div style={styles.formLayout}>
//               <div style={styles.twoColumnLayout}>
//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>📦 Product Details</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>
//                       Product Type<span style={styles.requiredAsterisk}>*</span>
//                     </label>
//                     <select
//                       name="productType"
//                       value={formData.productType}
//                       onChange={handleChange}
//                       style={focusedField === 'productType' ? { ...styles.select, ...styles.selectFocused } : styles.select}
//                       onFocus={() => setFocusedField('productType')}
//                       onBlur={() => setFocusedField('')}
//                       required
//                     >
//                       <option value="">Select Product Type</option>
//                       <option value="STOCK">Stock</option>
//                       <option value="NON-STOCK">Non Stock</option>
//                     </select>
//                   </div>

//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>
//                       Batch Product<span style={styles.requiredAsterisk}>*</span>
//                     </label>
//                     <select
//                       name="batchProduct"
//                       value={formData.batchProduct}
//                       onChange={handleChange}
//                       style={focusedField === 'batchProduct' ? { ...styles.select, ...styles.selectFocused } : styles.select}
//                       onFocus={() => setFocusedField('batchProduct')}
//                       onBlur={() => setFocusedField('')}
//                       required
//                     >
//                       <option value="">Select Batch Product</option>
//                       <option value="Yes">Yes</option>
//                       <option value="No">No</option>
//                     </select>
//                   </div>

//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>HSN/SAC Code</label>
//                     <input
//                       type="text"
//                       name="hsnSacCode"
//                       value={formData.hsnSacCode}
//                       onChange={handleChange}
//                       style={focusedField === 'hsnSacCode' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                       onFocus={() => setFocusedField('hsnSacCode')}
//                       onBlur={() => setFocusedField('')}
//                       placeholder="Enter HSN/SAC Code (Numbers only)"
//                     />
//                   </div>

//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>
//                       Product Name<span style={styles.requiredAsterisk}>*</span>
//                     </label>
//                     <input
//                       type="text"
//                       name="productName"
//                       value={formData.productName}
//                       onChange={handleChange}
//                       style={focusedField === 'productName' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                       onFocus={() => setFocusedField('productName')}
//                       onBlur={() => setFocusedField('')}
//                       placeholder="Enter product name"
//                       required
//                     />
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Barcode Type<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <select
//                         name="barcodeType"
//                         value={formData.barcodeType}
//                         onChange={handleChange}
//                         style={focusedField === 'barcodeType' ? { ...styles.select, ...styles.selectFocused } : styles.select}
//                         onFocus={() => setFocusedField('barcodeType')}
//                         onBlur={() => setFocusedField('')}
//                         required
//                       >
//                         <option value="">Select Barcode Type</option>
//                         <option value="Company Barcode">Company Barcode</option>
//                         <option value="Own Barcode">Own Barcode</option>
//                       </select>
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Barcode<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <input
//                         type="text"
//                         name="barcode"
//                         value={formData.barcode}
//                         onChange={handleChange}
//                         maxLength="13"
//                         style={focusedField === 'barcode' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('barcode')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="Enter Barcode (Max 13 digits)"
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Group<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <div style={styles.flexRow}>
//                         <select
//                           name="group"
//                           value={formData.group}
//                           onChange={handleChange}
//                           style={focusedField === 'group' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
//                           onFocus={() => setFocusedField('group')}
//                           onBlur={() => setFocusedField('')}
//                           required
//                         >
//                           <option value="">Select Group</option>
//                           {groups.map((group) => (
//                             <option key={group.id} value={group.name}>
//                               {group.name}
//                             </option>
//                           ))}
//                         </select>
//                         <button
//                           type="button"
//                           onClick={() => setShowGroupInput(!showGroupInput)}
//                           style={styles.addButton}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {showGroupInput && (
//                         <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
//                           <input
//                             type="text"
//                             value={newGroup}
//                             onChange={(e) => handleNewItemChange(e, setNewGroup, 'Group')}
//                             style={focusedField === 'newGroup' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
//                             onFocus={() => setFocusedField('newGroup')}
//                             onBlur={() => setFocusedField('')}
//                             placeholder="New group (Alphabets only)"
//                           />
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleAddItem('Group', newGroup, setNewGroup, setShowGroupInput, setGroups, 'group')
//                             }
//                             style={styles.addButton}
//                           >
//                             ✓
//                           </button>
//                         </div>
//                       )}
//                     </div>

//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Category</label>
//                       <div style={styles.flexRow}>
//                         <select
//                           name="category"
//                           value={formData.category}
//                           onChange={handleChange}
//                           style={focusedField === 'category' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
//                           onFocus={() => setFocusedField('category')}
//                           onBlur={() => setFocusedField('')}
//                         >
//                           <option value="">Select Category</option>
//                           {categories.map((category) => (
//                             <option key={category.id} value={category.name}>
//                               {category.name}
//                             </option>
//                           ))}
//                         </select>
//                         <button
//                           type="button"
//                           onClick={() => setShowCategoryInput(!showCategoryInput)}
//                           style={styles.addButton}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {showCategoryInput && (
//                         <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
//                           <input
//                             type="text"
//                             value={newCategory}
//                             onChange={(e) => handleNewItemChange(e, setNewCategory, 'Category')}
//                             style={focusedField === 'newCategory' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
//                             onFocus={() => setFocusedField('newCategory')}
//                             onBlur={() => setFocusedField('')}
//                             placeholder="New category (Alphabets only)"
//                           />
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleAddItem('Category', newCategory, setNewCategory, setShowCategoryInput, setCategories, 'category')
//                             }
//                             style={styles.addButton}
//                           >
//                             ✓
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Brand<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <div style={styles.flexRow}>
//                         <select
//                           name="brand"
//                           value={formData.brand}
//                           onChange={handleChange}
//                           style={focusedField === 'brand' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
//                           onFocus={() => setFocusedField('brand')}
//                           onBlur={() => setFocusedField('')}
//                           required
//                         >
//                           <option value="">Select Brand</option>
//                           {brands.map((brand) => (
//                             <option key={brand.id} value={brand.name}>
//                               {brand.name}
//                             </option>
//                           ))}
//                         </select>
//                         <button
//                           type="button"
//                           onClick={() => setShowBrandInput(!showBrandInput)}
//                           style={styles.addButton}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {showBrandInput && (
//                         <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
//                           <input
//                             type="text"
//                             value={newBrand}
//                             onChange={(e) => handleNewItemChange(e, setNewBrand, 'Brand')}
//                             style={focusedField === 'newBrand' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
//                             onFocus={() => setFocusedField('newBrand')}
//                             onBlur={() => setFocusedField('')}
//                             placeholder="New brand (Alphabets only)"
//                           />
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleAddItem('Brand', newBrand, setNewBrand, setShowBrandInput, setBrands, 'brand')
//                             }
//                             style={styles.addButton}
//                           >
//                             ✓
//                           </button>
//                         </div>
//                       )}
//                     </div>

//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>UOM</label>
//                       <div style={styles.flexRow}>
//                         <select
//                           name="unit"
//                           value={formData.unit}
//                           onChange={handleChange}
//                           style={focusedField === 'unit' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
//                           onFocus={() => setFocusedField('unit')}
//                           onBlur={() => setFocusedField('')}
//                         >
//                           <option value="">Select Unit</option>
//                           {units.map((unit) => (
//                             <option key={unit.id} value={unit.name}>
//                               {unit.name}
//                             </option>
//                           ))}
//                         </select>
//                         <button
//                           type="button"
//                           onClick={() => setShowUnitInput(!showUnitInput)}
//                           style={styles.addButton}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {showUnitInput && (
//                         <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
//                           <input
//                             type="text"
//                             value={newUnit}
//                             onChange={(e) => {
//                               const value = e.target.value;
//                               setNewUnit(value);
//                               setErrorMessage('');
//                             }}
//                             style={focusedField === 'newUnit' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
//                             onFocus={() => setFocusedField('newUnit')}
//                             onBlur={() => setFocusedField('')}
//                             placeholder="Enter unit"
//                           />
//                           <button
//                             type="button"
//                             onClick={() => {
//                               handleAddItem('Unit', newUnit, setNewUnit, setShowUnitInput, setUnits, 'unit');
//                             }}
//                             style={styles.addButton}
//                           >
//                             ✓
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Style</label>
//                     <input
//                       type="text"
//                       name="style"
//                       value={formData.style}
//                       onChange={handleChange}
//                       style={focusedField === 'style' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                       onFocus={() => setFocusedField('style')}
//                       onBlur={() => setFocusedField('')}
//                       placeholder="Enter style (Alphabets only)"
//                     />
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Label No</label>
//                       <input
//                         type="text"
//                         name="labelNo"
//                         value={formData.labelNo}
//                         onChange={handleChange}
//                         style={focusedField === 'labelNo' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('labelNo')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="Enter Label No (Alphabets and Numbers)"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Type</label>
//                       <input
//                         type="text"
//                         name="type"
//                         value={formData.type}
//                         onChange={handleChange}
//                         style={focusedField === 'type' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('type')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="Enter Type (Alphabets and Numbers)"
//                       />
//                     </div>
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Location</label>
//                       <input
//                         type="text"
//                         name="location"
//                         value={formData.location}
//                         onChange={handleChange}
//                         style={focusedField === 'location' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('location')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="Enter Location (Alphabets only)"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Design No</label>
//                       <div style={styles.flexRow}>
//                         <select
//                           name="designNo"
//                           value={formData.designNo}
//                           onChange={handleChange}
//                           style={focusedField === 'designNo' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
//                           onFocus={() => setFocusedField('designNo')}
//                           onBlur={() => setFocusedField('')}
//                         >
//                           <option value="">Select Design No</option>
//                           {designNumbers.map((design) => (
//                             <option key={design.id} value={design.designNo}>
//                               {design.designNo}
//                             </option>
//                           ))}
//                         </select>
//                         <button
//                           type="button"
//                           onClick={() => setShowDesignNoInput(!showDesignNoInput)}
//                           style={styles.addButton}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {showDesignNoInput && (
//                         <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
//                           <input
//                             type="text"
//                             value={newDesignNo}
//                             onChange={(e) => handleNewItemChange(e, setNewDesignNo, 'DesignNo')}
//                             style={focusedField === 'newDesignNo' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
//                             onFocus={() => setFocusedField('newDesignNo')}
//                             onBlur={() => setFocusedField('')}
//                             placeholder="New design number (Alphabets and Numbers)"
//                           />
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleAddItem('DesignNo', newDesignNo, setNewDesignNo, setShowDesignNoInput, setDesignNumbers, 'designNo')
//                             }
//                             style={styles.addButton}
//                           >
//                             ✓
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>💰 Price Information</h2>
//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         MRP<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="mrp"
//                         value={formData.mrp}
//                         onChange={handleChange}
//                         style={focusedField === 'mrp' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('mrp')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="0.00"
//                         required
//                         min="0"
//                         step="0.01"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Purchase Rate (Excl. Tax)<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="purchaseRateExclTax"
//                         value={formData.purchaseRateExclTax}
//                         onChange={handleChange}
//                         style={focusedField === 'purchaseRateExclTax' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('purchaseRateExclTax')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="0.00"
//                         required
//                         min="0"
//                         step="0.01"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Selling Rate<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="sellingRate"
//                         value={formData.sellingRate}
//                         onChange={handleChange}
//                         style={focusedField === 'sellingRate' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('sellingRate')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="0.00"
//                         required
//                         min="0"
//                         step="0.01"
//                       />
//                     </div>
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Margin (%)</label>
//                       <input
//                         type="text"
//                         name="margin"
//                         value={formData.margin}
//                         style={{ ...styles.input, ...styles.readOnlyInput }}
//                         readOnly
//                         placeholder="Auto-calculated"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Discount (%)</label>
//                       <input
//                         type="text"
//                         name="discount"
//                         value={formData.discount}
//                         style={{ ...styles.input, ...styles.readOnlyInput }}
//                         readOnly
//                         placeholder="Auto-calculated"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Savings (₹)</label>
//                       <input
//                         type="text"
//                         name="savings"
//                         value={formData.savings}
//                         style={{ ...styles.input, ...styles.readOnlyInput }}
//                         readOnly
//                         placeholder="Auto-calculated"
//                       />
//                     </div>
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Purchase Tax (%)<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <select
//                         name="purchaseTax"
//                         value={formData.purchaseTax}
//                         onChange={handleChange}
//                         style={focusedField === 'purchaseTax' ? { ...styles.select, ...styles.selectFocused } : styles.select}
//                         onFocus={() => setFocusedField('purchaseTax')}
//                         onBlur={() => setFocusedField('')}
//                         required
//                       >
//                         <option value="">Select Purchase Tax</option>
//                         {taxes.map((tax) => (
//                           <option key={tax.id} value={tax.description}>
//                             {`${tax.description} (${tax.cgst || tax.sgst || tax.igst || 0}%)`}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Cess Tax (%)</label>
//                       <select
//                         name="cessTax"
//                         value={formData.cessTax}
//                         onChange={handleChange}
//                         style={focusedField === 'cessTax' ? { ...styles.select, ...styles.selectFocused } : styles.select}
//                         onFocus={() => setFocusedField('cessTax')}
//                         onBlur={() => setFocusedField('')}
//                       >
//                         <option value="">Select Cess Tax</option>
//                         <option value="0">CESS 0%</option>
//                       </select>
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>
//                         Sales Tax (%)<span style={styles.requiredAsterisk}>*</span>
//                       </label>
//                       <select
//                         name="salesTax"
//                         value={formData.salesTax}
//                         onChange={handleChange}
//                         style={focusedField === 'salesTax' ? { ...styles.select, ...styles.selectFocused } : styles.select}
//                         onFocus={() => setFocusedField('salesTax')}
//                         onBlur={() => setFocusedField('')}
//                         required
//                       >
//                         <option value="">Select Sales Tax</option>
//                         {taxes.map((tax) => (
//                           <option key={tax.id} value={tax.description}>
//                             {`${tax.description} (${tax.cgst || tax.sgst || tax.igst || 0}%)`}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>

//                   <div style={styles.gridTwoColumns}>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Purchase Rate (Incl. Tax)</label>
//                       <input
//                         type="text"
//                         name="costPriceInclTax"
//                         value={formData.costPriceInclTax}
//                         style={{ ...styles.input, ...styles.readOnlyInput }}
//                         readOnly
//                         placeholder="Auto-calculated"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Selling Price (Incl. Tax)</label>
//                       <input
//                         type="text"
//                         name="sellingPriceInclTax"
//                         value={formData.sellingPriceInclTax}
//                         style={{ ...styles.input, ...styles.readOnlyInput }}
//                         readOnly
//                         placeholder="Auto-calculated"
//                       />
//                     </div>
//                     <div style={styles.inputGroup}>
//                       <label style={styles.label}>Wholesale Rate</label>
//                       <input
//                         type="number"
//                         name="wholesaleRate"
//                         value={formData.wholesaleRate}
//                         onChange={handleChange}
//                         style={focusedField === 'wholesaleRate' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                         onFocus={() => setFocusedField('wholesaleRate')}
//                         onBlur={() => setFocusedField('')}
//                         placeholder="0.00"
//                         min="0"
//                         step="0.01"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.section}>
//                 <h2 style={styles.sectionHeading}>📊 Stock Information</h2>
//                 <div style={styles.gridTwoColumns}>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Low Stock Alert</label>
//                     <input
//                       type="number"
//                       name="lowStockAlert"
//                       value={formData.lowStockAlert}
//                       onChange={handleChange}
//                       style={focusedField === 'lowStockAlert' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                       onFocus={() => setFocusedField('lowStockAlert')}
//                       onBlur={() => setFocusedField('')}
//                       placeholder="0"
//                       min="0"
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Re-order Qty</label>
//                     <input
//                       type="number"
//                       name="reorderQty"
//                       value={formData.reorderQty}
//                       onChange={handleChange}
//                       style={focusedField === 'reorderQty' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                       onFocus={() => setFocusedField('reorderQty')}
//                       onBlur={() => setFocusedField('')}
//                       placeholder="0"
//                       min="0"
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Opening Stock</label>
//                     <input
//                       type="number"
//                       name="openingStock"
//                       value={formData.openingStock}
//                       onChange={handleChange}
//                       style={focusedField === 'openingStock' ? { ...styles.input, ...styles.inputFocused } : styles.input}
//                       onFocus={() => setFocusedField('openingStock')}
//                       onBlur={() => setFocusedField('')}
//                       placeholder="0"
//                       min="0"
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.section}>
//                 <h2 style={styles.sectionHeading}>🖼️ Product Image</h2>
//                 <div style={styles.imageUploadSection}>
//                   <input
//                     type="file"
//                     id="imageUpload"
//                     accept="image/*"
//                     onChange={(e) => {
//                       const file = e.target.files[0];
//                       if (file) {
//                         setFormData({ ...formData, image: file });
//                         setImagePreview(URL.createObjectURL(file));
//                       }
//                     }}
//                     style={styles.fileInput}
//                   />
//                   <label htmlFor="imageUpload" style={styles.fileInputLabel}>
//                     📷 Choose Image
//                   </label>
//                   <p style={{ marginTop: '0.5rem', color: '#6b7280', fontSize: '0.875rem' }}>
//                     Maximum file size: 5MB (JPEG, PNG, GIF)
//                   </p>
//                   {imagePreview && (
//                     <div style={{ marginTop: '1rem' }}>
//                       <img src={imagePreview} alt="Preview" style={styles.imagePreview} />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div style={styles.buttonContainer}>
//               <button
//                 type="button"
//                 onClick={() => {
//                   resetForm();
//                   onCancel();
//                 }}
//                 style={{ ...styles.button, ...styles.cancelButton }}
//                 disabled={submitting}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 style={{ ...styles.button, ...styles.submitButton }}
//                 disabled={submitting}
//               >
//                 {submitting ? '⏳ Saving...' : editingProduct ? 'Update Product' : 'Add Product'}
//               </button>
//             </div>
//           </form>
//         )}
//       </div>

//       <style jsx>{`
//         @keyframes spin {
//           0% {
//             transform: rotate(0deg);
//           }
//           100% {
//             transform: rotate(360deg);
//           }
//         }
//         @media (max-width: 768px) {
//           .twoColumnLayout {
//             grid-template-columns: 1fr;
//           }
//           .gridTwoColumns {
//             grid-template-columns: 1fr;
//           }
//           .gridThreeColumns {
//             grid-template-columns: 1fr;
//           }
//           .buttonContainer {
//             flex-direction: column;
//           }
//           .button {
//             width: 100%;
//             justify-content: center;
//           }
//         }
//         button:hover:not(:disabled) {
//           filter: brightness(90%);
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ProductForm;

import React, { useState, useEffect } from 'react';
import { storage, database, auth } from '../firebase';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { ref, push, update, serverTimestamp, onValue, off, remove, get } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';

const ProductForm = ({ editingProduct, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    productType: '',
    batchProduct: '',
    hsnSacCode: '',
    productName: '',
    barcodeType: '',
    barcode: '',
    group: '',
    category: '',
    brand: '',
    unit: '',
    style: '',
    mrp: '',
    sellingRate: '',
    purchaseRateExclTax: '',
    margin: '',
    discount: '',
    savings: '',
    cessTax: '',
    purchaseTax: '',
    salesTax: '',
    costPriceInclTax: '',
    sellingPriceInclTax: '',
    wholesaleRate: '',
    lowStockAlert: '',
    reorderQty: '',
    openingStock: '',
    image: null,
    labelNo: '',
    type: '',
    typeMultiplier: '1', // New field for dropdown multiplier
    location: '',
    designNo: '',
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [newGroup, setNewGroup] = useState('');
  const [newCategory, setNewCategory] = useState('');
  const [newBrand, setNewBrand] = useState('');
  const [newUnit, setNewUnit] = useState('');
  const [newDesignNo, setNewDesignNo] = useState('');
  const [showGroupInput, setShowGroupInput] = useState(false);
  const [showCategoryInput, setShowCategoryInput] = useState(false);
  const [showBrandInput, setShowBrandInput] = useState(false);
  const [showUnitInput, setShowUnitInput] = useState(false);
  const [showDesignNoInput, setShowDesignNoInput] = useState(false);
  const [customUnits, setCustomUnits] = useState([]);
  const [newCustomUnit, setNewCustomUnit] = useState({ baseUnit: '', conversionRate: '', secondaryUnit: '' });
  const [showCustomUnitInput, setShowCustomUnitInput] = useState(false);
  const [groups, setGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [designNumbers, setDesignNumbers] = useState([]);
  const [focusedField, setFocusedField] = useState('');

  // Multiplier options for the type dropdown
  const multiplierOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, '_');
  };

  useEffect(() => {
    if (editingProduct) {
      setFormData({
        productType: editingProduct.productType || '',
        batchProduct: editingProduct.batchProduct || '',
        hsnSacCode: editingProduct.hsnSacCode || '',
        productName: editingProduct.productName || '',
        barcodeType: editingProduct.barcodeType || '',
        barcode: editingProduct.barcode || '',
        group: editingProduct.group || '',
        category: editingProduct.category || '',
        brand: editingProduct.brand || '',
        unit: editingProduct.unit || '',
        style: editingProduct.style || '',
        mrp: editingProduct.mrp || '',
        sellingRate: editingProduct.sellingRate || '',
        purchaseRateExclTax: editingProduct.purchaseRateExclTax || '',
        margin: editingProduct.margin || '',
        discount: editingProduct.discount || '',
        savings: editingProduct.savings || '',
        cessTax: editingProduct.cessTax || '',
        purchaseTax: editingProduct.purchaseTax || '',
        salesTax: editingProduct.salesTax || '',
        costPriceInclTax: editingProduct.costPriceInclTax || '',
        sellingPriceInclTax: editingProduct.sellingPriceInclTax || '',
        wholesaleRate: editingProduct.wholesaleRate || '',
        lowStockAlert: editingProduct.lowStockAlert || '',
        reorderQty: editingProduct.reorderQty || '',
        openingStock: editingProduct.openingStock || '',
        image: null,
        labelNo: editingProduct.labelNo || '',
        type: editingProduct.type || '',
        typeMultiplier: editingProduct.typeMultiplier || '1',
        location: editingProduct.location || '',
        designNo: editingProduct.designNo || '',
      });
      if (editingProduct.image) {
        setImagePreview(editingProduct.image);
      }
      if (editingProduct.customUnits) {
        setCustomUnits(
          Object.entries(editingProduct.customUnits).map(([id, data]) => ({
            id,
            ...data,
          }))
        );
      }
    }
  }, [editingProduct]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    const encodedEmail = encodeEmailForPath(currentUser.email);

    const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
    const groupsListener = onValue(groupsRef, (snapshot) => {
      const groupsData = [];
      snapshot.forEach((childSnapshot) => {
        groupsData.push({
          id: childSnapshot.key,
          ...childSnapshot.val(),
        });
      });
      setGroups(groupsData);
    });

    const categoriesRef = ref(database, `users/${encodedEmail}/categories`);
    const categoriesListener = onValue(categoriesRef, (snapshot) => {
      const categoriesData = [];
      snapshot.forEach((childSnapshot) => {
        categoriesData.push({
          id: childSnapshot.key,
          ...childSnapshot.val(),
        });
      });
      setCategories(categoriesData);
    });

    const brandsRef = ref(database, `users/${encodedEmail}/brands`);
    const brandsListener = onValue(brandsRef, (snapshot) => {
      const brandsData = [];
      snapshot.forEach((childSnapshot) => {
        brandsData.push({
          id: childSnapshot.key,
          ...childSnapshot.val(),
        });
      });
      setBrands(brandsData);
    });

    const unitsRef = ref(database, `users/${encodedEmail}/units`);
    const unitsListener = onValue(unitsRef, (snapshot) => {
      const unitsData = [];
      snapshot.forEach((childSnapshot) => {
        unitsData.push({
          id: childSnapshot.key,
          ...childSnapshot.val(),
        });
      });
      setUnits(unitsData);
    });

    const taxesRef = ref(database, `users/${encodedEmail}/gstTaxes`);
    const taxesListener = onValue(taxesRef, (snapshot) => {
      const taxesData = [];
      snapshot.forEach((childSnapshot) => {
        taxesData.push({
          id: childSnapshot.key,
          ...childSnapshot.val(),
        });
      });
      setTaxes(taxesData);
    });

    const designsRef = ref(database, `users/${encodedEmail}/designNumbers`);
    const designsListener = onValue(designsRef, (snapshot) => {
      const designsData = [];
      snapshot.forEach((childSnapshot) => {
        designsData.push({
          id: childSnapshot.key,
          ...childSnapshot.val(),
        });
      });
      setDesignNumbers(designsData);
      setLoading(false);
    });

    return () => {
      off(groupsRef);
      off(categoriesRef);
      off(brandsRef);
      off(unitsRef);
      off(taxesRef);
      off(designsRef);
    };
  }, [currentUser]);

  useEffect(() => {
    const typeValue = parseFloat(formData.type) || 0;
    const multiplier = parseFloat(formData.typeMultiplier) || 1;
    const calculatedMrp = typeValue * multiplier;

    const sellingPrice = parseFloat(formData.sellingRate) || 0;
    const costPrice = parseFloat(formData.purchaseRateExclTax) || 0;
    const mrp = calculatedMrp || parseFloat(formData.mrp) || 0;
    const purchaseTax = parseFloat(formData.purchaseTax) || 0;
    const cessTax = parseFloat(formData.cessTax) || 0;
    const salesTax = parseFloat(formData.salesTax) || 0;

    let margin = 0;
    if (sellingPrice > 0) {
      margin = ((sellingPrice - costPrice) / sellingPrice) * 100;
    }

    let discount = 0;
    if (mrp > 0) {
      discount = ((mrp - sellingPrice) / mrp) * 100;
    }

    const savings = mrp - sellingPrice;

    const costPriceInclTax = costPrice * (1 + (purchaseTax + cessTax) / 100);

    const sellingPriceInclTax = sellingPrice * (1 + (salesTax + cessTax) / 100);

    setFormData((prev) => ({
      ...prev,
      mrp: isNaN(calculatedMrp) ? prev.mrp : calculatedMrp.toFixed(2),
      margin: isNaN(margin) ? '0.00' : margin.toFixed(2),
      discount: isNaN(discount) ? '0.00' : discount.toFixed(2),
      savings: savings > 0 ? savings.toFixed(2) : '0.00',
      costPriceInclTax: isNaN(costPriceInclTax) ? '0.00' : costPriceInclTax.toFixed(2),
      sellingPriceInclTax: isNaN(sellingPriceInclTax) ? '0.00' : sellingPriceInclTax.toFixed(2),
    }));
  }, [formData.type, formData.typeMultiplier, formData.sellingRate, formData.purchaseRateExclTax, formData.purchaseTax, formData.cessTax, formData.salesTax]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'hsnSacCode' && value && !/^\d*$/.test(value)) {
      setErrorMessage('HSN/SAC Code must contain only numbers');
      return;
    }

    if (name === 'barcode' && value) {
      if (!/^\d*$/.test(value)) {
        setErrorMessage('Barcode must contain only numbers');
        return;
      }
      if (value.length > 13) {
        setErrorMessage('Barcode cannot exceed 13 digits');
        return;
      }
    }

    if ((name === 'style' || name === 'location') && value && !/^[a-zA-Z\s]*$/.test(value)) {
      setErrorMessage(`${name.charAt(0).toUpperCase() + name.slice(1)} must contain only alphabets`);
      return;
    }

    if (name === 'labelNo' || name === 'type') {
      if (value && !/^[a-zA-Z0-9\s]*$/.test(value)) {
        setErrorMessage(`${name.charAt(0).toUpperCase() + name.slice(1)} must contain only alphabets and numbers`);
        return;
      }
    }

    setFormData({ ...formData, [name]: value });
    setErrorMessage('');
  };

  const handleNewItemChange = (e, setValue, type) => {
    const value = e.target.value;
    if (type === 'DesignNo' && value && !/^[a-zA-Z0-9\s]*$/.test(value)) {
      setErrorMessage('Design Number must contain only alphabets and numbers');
      return;
    } else if (value && !/^[a-zA-Z\s]*$/.test(value)) {
      if (type === 'Unit') {
        setErrorMessage('Enter a valid unit (e.g., ltr, ml, gm, kg, ms). Only letters allowed.');
      } else {
        setErrorMessage(`${type} must contain only alphabets`);
      }
      return;
    }
    setValue(value);
    setErrorMessage('');
  };

  const handleAddItem = async (type, value, setValue, setShowInput, setItems, formField) => {
    if (!value.trim()) {
      setErrorMessage(`Please enter a valid ${type}`);
      return;
    }
    if (type === 'DesignNo' && !/^[a-zA-Z0-9\s]*$/.test(value)) {
      setErrorMessage('Design Number must contain only alphabets and numbers');
      return;
    } else if (!/^[a-zA-Z\s]*$/.test(value)) {
      if (type === 'Unit') {
        setErrorMessage('Enter a valid unit (e.g., ltr, ml, gm, kg, ms). Only letters allowed.');
      } else {
        setErrorMessage(`${type} must contain only alphabets`);
      }
      return;
    }
    if (!currentUser) {
      setErrorMessage('You must be logged in to add items');
      return;
    }

    try {
      const encodedEmail = encodeEmailForPath(currentUser.email);
      const itemRef = ref(database, `users/${encodedEmail}/${type === 'Group' ? 'productGroups' : type === 'DesignNo' ? 'designNumbers' : type.toLowerCase() + 's'}`);

      const newItemRef = await push(itemRef, { [type === 'DesignNo' ? 'designNo' : 'name']: value.trim() });
      setItems((prev) => [
        ...prev,
        {
          id: newItemRef.key,
          [type === 'DesignNo' ? 'designNo' : 'name']: value.trim(),
        },
      ]);
      setFormData((prev) => ({
        ...prev,
        [formField]: value.trim(),
      }));
      setValue('');
      setShowInput(false);
      setSuccessMessage(`${type} added successfully!`);
    } catch (error) {
      setErrorMessage(`Error adding ${type}: ${error.message}`);
    }
  };

  const handleAddCustomUnit = async () => {
    if (!newCustomUnit.baseUnit || !newCustomUnit.conversionRate || !newCustomUnit.secondaryUnit) {
      setErrorMessage('Please fill in all custom unit fields');
      return;
    }
    if (!currentUser) {
      setErrorMessage('You must be logged in to add custom units');
      return;
    }

    try {
      const encodedEmail = encodeEmailForPath(currentUser.email);
      const customUnitsRef = ref(database, `users/${encodedEmail}/customUnits`);
      const newUnitRef = await push(customUnitsRef, {
        baseUnit: newCustomUnit.baseUnit,
        conversionRate: parseFloat(newCustomUnit.conversionRate),
        secondaryUnit: newCustomUnit.secondaryUnit,
      });
      setCustomUnits([
        ...customUnits,
        {
          id: newUnitRef.key,
          baseUnit: newCustomUnit.baseUnit,
          conversionRate: parseFloat(newCustomUnit.conversionRate),
          secondaryUnit: newCustomUnit.secondaryUnit,
        },
      ]);
      setNewCustomUnit({ baseUnit: '', conversionRate: '', secondaryUnit: '' });
      setShowCustomUnitInput(false);
      setSuccessMessage('Custom unit added successfully!');
    } catch (error) {
      setErrorMessage(`Error adding custom unit: ${error.message}`);
    }
  };

  const handleDeleteCustomUnit = async (id) => {
    if (!currentUser) {
      setErrorMessage('You must be logged in to delete custom units');
      return;
    }

    try {
      const encodedEmail = encodeEmailForPath(currentUser.email);
      const unitRef = ref(database, `users/${encodedEmail}/customUnits/${id}`);
      await remove(unitRef);
      setCustomUnits(customUnits.filter((unit) => unit.id !== id));
      setSuccessMessage('Custom unit deleted successfully!');
    } catch (error) {
      setErrorMessage(`Error deleting custom unit: ${error.message}`);
    }
  };

  const getNextProductId = async (encodedEmail) => {
    const productsRef = ref(database, `users/${encodedEmail}/products`);
    const snapshot = await get(productsRef);

    if (!snapshot.exists()) {
      return 1;
    }

    const products = snapshot.val();
    const ids = Object.keys(products)
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id));

    if (ids.length === 0) {
      return 1;
    }

    return Math.max(...ids) + 1;
  };

  const isFormChanged = () => {
    if (!editingProduct) return true;
    return (
      Object.keys(formData).some((key) => {
        if (key === 'image') return !!formData.image;
        return formData[key] !== (editingProduct[key] || '');
      }) || customUnits.length !== Object.keys(editingProduct.customUnits || {}).length
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    setSubmitting(true);

    if (!currentUser) {
      setErrorMessage('You must be logged in to add a product');
      setSubmitting(false);
      return;
    }

    if (!formData.productType) {
      setErrorMessage('Please select a Product Type');
      setSubmitting(false);
      return;
    }

    if (!formData.batchProduct) {
      setErrorMessage('Please select Batch Product option');
      setSubmitting(false);
      return;
    }

    try {
      let imageUrl = editingProduct?.image || '';
      if (formData.image) {
        if (formData.image.size > 5 * 1024 * 1024) {
          setErrorMessage('Image size should be less than 5MB');
          setSubmitting(false);
          return;
        }

        const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
        if (!validTypes.includes(formData.image.type)) {
          setErrorMessage('Please upload a valid image file (JPEG, PNG, or GIF)');
          setSubmitting(false);
          return;
        }

        const timestamp = new Date().getTime();
        const filename = `${timestamp}_${formData.image.name}`;
        const fileRef = storageRef(storage, `products/${filename}`);
        const uploadResult = await uploadBytes(fileRef, formData.image);
        imageUrl = await getDownloadURL(uploadResult.ref);
      }

      const customUnitsObject = customUnits.reduce((acc, unit) => {
        acc[unit.id] = {
          baseUnit: unit.baseUnit,
          conversionRate: unit.conversionRate,
          secondaryUnit: unit.secondaryUnit,
        };
        return acc;
      }, {});

      const productData = {
        ...formData,
        image: imageUrl,
        customUnits: customUnitsObject,
        createdAt: editingProduct ? editingProduct.createdAt : serverTimestamp(),
        createdBy: currentUser.email,
        mrp: parseFloat(formData.mrp) || 0,
        sellingRate: parseFloat(formData.sellingRate) || 0,
        purchaseRateExclTax: parseFloat(formData.purchaseRateExclTax) || 0,
        margin: parseFloat(formData.margin) || 0,
        discount: parseFloat(formData.discount) || 0,
        savings: parseFloat(formData.savings) || 0,
        cessTax: parseFloat(formData.cessTax) || 0,
        purchaseTax: parseFloat(formData.purchaseTax) || 0,
        salesTax: parseFloat(formData.salesTax) || 0,
        costPriceInclTax: parseFloat(formData.costPriceInclTax) || 0,
        sellingPriceInclTax: parseFloat(formData.sellingPriceInclTax) || 0,
        wholesaleRate: parseFloat(formData.wholesaleRate) || 0,
        lowStockAlert: parseInt(formData.lowStockAlert) || 0,
        reorderQty: parseInt(formData.reorderQty) || 0,
        openingStock: parseInt(formData.openingStock) || 0,
        labelNo: formData.labelNo || '',
        type: formData.type || '',
        typeMultiplier: formData.typeMultiplier || '1',
        location: formData.location || '',
        designNo: formData.designNo || '',
      };

      delete productData.image;

      const encodedEmail = encodeEmailForPath(currentUser.email);

      if (editingProduct) {
        if (!isFormChanged()) {
          setErrorMessage('No changes detected.');
          setSubmitting(false);
          return;
        }
        const productRef = ref(database, `users/${encodedEmail}/products/${editingProduct.id}`);
        await update(productRef, productData);
        alert('Product Updated Successfully.');
        setSuccessMessage('Product Updated Successfully.');
      } else {
        const nextId = await getNextProductId(encodedEmail);
        const productRef = ref(database, `users/${encodedEmail}/products/${nextId}`);
        await update(productRef, productData);
        alert('Product added successfully!');
        setSuccessMessage('Product added successfully!');
      }

      resetForm();
      onSuccess();
    } catch (error) {
      console.error('Error adding/updating product:', error);
      setErrorMessage(`Error: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      productType: '',
      batchProduct: '',
      hsnSacCode: '',
      productName: '',
      barcodeType: '',
      barcode: '',
      group: '',
      category: '',
      brand: '',
      unit: '',
      style: '',
      mrp: '',
      sellingRate: '',
      purchaseRateExclTax: '',
      margin: '',
      discount: '',
      savings: '',
      cessTax: '',
      purchaseTax: '',
      salesTax: '',
      costPriceInclTax: '',
      sellingPriceInclTax: '',
      wholesaleRate: '',
      lowStockAlert: '',
      reorderQty: '',
      openingStock: '',
      image: null,
      labelNo: '',
      type: '',
      typeMultiplier: '1',
      location: '',
      designNo: '',
    });
    setImagePreview(null);
    setNewGroup('');
    setNewCategory('');
    setNewBrand('');
    setNewUnit('');
    setNewDesignNo('');
    setShowGroupInput(false);
    setShowCategoryInput(false);
    setShowBrandInput(false);
    setShowUnitInput(false);
    setShowDesignNoInput(false);
    setCustomUnits([]);
    setNewCustomUnit({ baseUnit: '', conversionRate: '', secondaryUnit: '' });
    setShowCustomUnitInput(false);
  };

  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '2rem auto',
      padding: '2rem',
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      minHeight: '100vh',
    },
    formWrapper: {
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      padding: '2.5rem',
      border: '1px solid #e2e8f0',
    },
    heading: {
      fontSize: '1.5rem',
      fontWeight: '700',
      marginBottom: '2rem',
      color: '#1f2937',
      textAlign: 'center',
    },
    messageSuccess: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#d1fae5',
      color: '#065f46',
      border: '1px solid #a7f3d0',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    messageError: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
      border: '1px solid #fecaca',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    loadingContainer: {
      textAlign: 'center',
      padding: '4rem 2rem',
      color: '#6b7280',
    },
    loadingSpinner: {
      width: '3rem',
      height: '3rem',
      border: '4px solid #e5e7eb',
      borderTop: '4px solid #2563eb',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      margin: '0 auto 1rem',
    },
    formLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '2rem',
    },
    twoColumnLayout: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: '2rem',
    },
    section: {
      backgroundColor: '#fff',
      padding: '1.5rem',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    },
    sectionHeading: {
      fontSize: '1.25rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#1f2937',
    },
    inputGroup: {
      marginBottom: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    label: {
      display: 'block',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '0.25rem',
    },
    requiredAsterisk: {
      color: '#ef4444',
      marginLeft: '0.25rem',
    },
    input: {
      display: 'block',
      width: '100%',
      padding: '0.3rem 0.5rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '1rem',
      backgroundColor: '#fff',
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
      boxSizing: 'border-box',
    },
    inputFocused: {
      borderColor: '#2563eb',
      boxShadow: '0 0 0 2px rgba(37, 99, 235, 0.1)',
    },
    select: {
      display: 'block',
      width: '100%',
      padding: '0.3rem 0.5rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '1rem',
      backgroundColor: '#fff',
      cursor: 'pointer',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: 'right 0.5rem center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '0.8em 0.8em',
      paddingRight: '1.5rem',
      boxSizing: 'border-box',
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    },
    selectFocused: {
      borderColor: '#2563eb',
      boxShadow: '0 0 0 2px rgba(37, 99, 235, 0.1)',
    },
    addButton: {
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#2563eb',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      fontSize: '0.875rem',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    gridTwoColumns: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '1rem',
    },
    gridThreeColumns: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
      gap: '1rem',
    },
    imageUploadSection: {
      padding: '1.5rem',
      border: '2px dashed #d1d5db',
      borderRadius: '8px',
      textAlign: 'center',
      backgroundColor: '#f9fafb',
    },
    fileInput: {
      display: 'none',
    },
    fileInputLabel: {
      display: 'inline-block',
      padding: '0.3rem 0.8rem',
      backgroundColor: '#2563eb',
      color: 'white',
      borderRadius: '6px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '1rem',
    },
    imagePreview: {
      marginTop: '1rem',
      width: '120px',
      height: '120px',
      objectFit: 'cover',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '1rem',
      border: '1px solid #e2e8f0',
    },
    th: {
      backgroundColor: '#f3f4f6',
      padding: '0.5rem',
      textAlign: 'left',
      fontWeight: '600',
      color: '#374151',
      borderBottom: '1px solid #e2e8f0',
    },
    td: {
      padding: '0.5rem',
      borderBottom: '1px solid #e2e8f0',
    },
    deleteButton: {
      padding: '0.25rem 0.5rem',
      backgroundColor: '#ef4444',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    buttonContainer: {
      marginTop: '2rem',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '1rem',
      paddingTop: '1rem',
      borderTop: '1px solid #e2e8f0',
    },
    button: {
      padding: '0.3rem 1rem',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '1rem',
      cursor: 'pointer',
      border: 'none',
      transition: 'all 0.2s ease',
    },
    submitButton: {
      backgroundColor: '#10b981',
      color: 'white',
    },
    cancelButton: {
      backgroundColor: '#ef4444',
      color: 'white',
    },
    flexRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    readOnlyInput: {
      backgroundColor: '#f3f4f6',
      color: '#6b7280',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.formWrapper}>
        <h1 style={styles.heading}>🛍️ {editingProduct ? 'Edit Product' : 'Add New Product'}</h1>

        {successMessage && (
          <div style={styles.messageSuccess}>
            <span>✅</span>
            {successMessage}
          </div>
        )}

        {errorMessage && (
          <div style={styles.messageError}>
            <span>❌</span>
            {errorMessage}
          </div>
        )}

        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner}></div>
            <p>Loading form data...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={styles.formLayout}>
              <div style={styles.twoColumnLayout}>
                <div style={styles.section}>
                  <h2 style={styles.sectionHeading}>📦 Product Details</h2>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>
                      Product Type<span style={styles.requiredAsterisk}>*</span>
                    </label>
                    <select
                      name="productType"
                      value={formData.productType}
                      onChange={handleChange}
                      style={focusedField === 'productType' ? { ...styles.select, ...styles.selectFocused } : styles.select}
                      onFocus={() => setFocusedField('productType')}
                      onBlur={() => setFocusedField('')}
                      required
                    >
                      <option value="">Select Product Type</option>
                      <option value="STOCK">Stock</option>
                      <option value="NON-STOCK">Non Stock</option>
                    </select>
                  </div>

                  <div style={styles.inputGroup}>
                    <label style={styles.label}>
                      Batch Product<span style={styles.requiredAsterisk}>*</span>
                    </label>
                    <select
                      name="batchProduct"
                      value={formData.batchProduct}
                      onChange={handleChange}
                      style={focusedField === 'batchProduct' ? { ...styles.select, ...styles.selectFocused } : styles.select}
                      onFocus={() => setFocusedField('batchProduct')}
                      onBlur={() => setFocusedField('')}
                      required
                    >
                      <option value="">Select Batch Product</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div style={styles.inputGroup}>
                    <label style={styles.label}>HSN/SAC Code</label>
                    <input
                      type="text"
                      name="hsnSacCode"
                      value={formData.hsnSacCode}
                      onChange={handleChange}
                      style={focusedField === 'hsnSacCode' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                      onFocus={() => setFocusedField('hsnSacCode')}
                      onBlur={() => setFocusedField('')}
                      placeholder="Enter HSN/SAC Code (Numbers only)"
                    />
                  </div>

                  <div style={styles.inputGroup}>
                    <label style={styles.label}>
                      Product Name<span style={styles.requiredAsterisk}>*</span>
                    </label>
                    <input
                      type="text"
                      name="productName"
                      value={formData.productName}
                      onChange={handleChange}
                      style={focusedField === 'productName' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                      onFocus={() => setFocusedField('productName')}
                      onBlur={() => setFocusedField('')}
                      placeholder="Enter product name"
                      required
                    />
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Barcode Type<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <select
                        name="barcodeType"
                        value={formData.barcodeType}
                        onChange={handleChange}
                        style={focusedField === 'barcodeType' ? { ...styles.select, ...styles.selectFocused } : styles.select}
                        onFocus={() => setFocusedField('barcodeType')}
                        onBlur={() => setFocusedField('')}
                        required
                      >
                        <option value="">Select Barcode Type</option>
                        <option value="Company Barcode">Company Barcode</option>
                        <option value="Own Barcode">Own Barcode</option>
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Barcode<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <input
                        type="text"
                        name="barcode"
                        value={formData.barcode}
                        onChange={handleChange}
                        maxLength="13"
                        style={focusedField === 'barcode' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                        onFocus={() => setFocusedField('barcode')}
                        onBlur={() => setFocusedField('')}
                        placeholder="Enter Barcode (Max 13 digits)"
                        required
                      />
                    </div>
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Group<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <div style={styles.flexRow}>
                        <select
                          name="group"
                          value={formData.group}
                          onChange={handleChange}
                          style={focusedField === 'group' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
                          onFocus={() => setFocusedField('group')}
                          onBlur={() => setFocusedField('')}
                          required
                        >
                          <option value="">Select Group</option>
                          {groups.map((group) => (
                            <option key={group.id} value={group.name}>
                              {group.name}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={() => setShowGroupInput(!showGroupInput)}
                          style={styles.addButton}
                        >
                          +
                        </button>
                      </div>
                      {showGroupInput && (
                        <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
                          <input
                            type="text"
                            value={newGroup}
                            onChange={(e) => handleNewItemChange(e, setNewGroup, 'Group')}
                            style={focusedField === 'newGroup' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
                            onFocus={() => setFocusedField('newGroup')}
                            onBlur={() => setFocusedField('')}
                            placeholder="New group (Alphabets only)"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              handleAddItem('Group', newGroup, setNewGroup, setShowGroupInput, setGroups, 'group')
                            }
                            style={styles.addButton}
                          >
                            ✓
                          </button>
                        </div>
                      )}
                    </div>

                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Category</label>
                      <div style={styles.flexRow}>
                        <select
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                          style={focusedField === 'category' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
                          onFocus={() => setFocusedField('category')}
                          onBlur={() => setFocusedField('')}
                        >
                          <option value="">Select Category</option>
                          {categories.map((category) => (
                            <option key={category.id} value={category.name}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={() => setShowCategoryInput(!showCategoryInput)}
                          style={styles.addButton}
                        >
                          +
                        </button>
                      </div>
                      {showCategoryInput && (
                        <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
                          <input
                            type="text"
                            value={newCategory}
                            onChange={(e) => handleNewItemChange(e, setNewCategory, 'Category')}
                            style={focusedField === 'newCategory' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
                            onFocus={() => setFocusedField('newCategory')}
                            onBlur={() => setFocusedField('')}
                            placeholder="New category (Alphabets only)"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              handleAddItem('Category', newCategory, setNewCategory, setShowCategoryInput, setCategories, 'category')
                            }
                            style={styles.addButton}
                          >
                            ✓
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Brand<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <div style={styles.flexRow}>
                        <select
                          name="brand"
                          value={formData.brand}
                          onChange={handleChange}
                          style={focusedField === 'brand' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
                          onFocus={() => setFocusedField('brand')}
                          onBlur={() => setFocusedField('')}
                          required
                        >
                          <option value="">Select Brand</option>
                          {brands.map((brand) => (
                            <option key={brand.id} value={brand.name}>
                              {brand.name}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={() => setShowBrandInput(!showBrandInput)}
                          style={styles.addButton}
                        >
                          +
                        </button>
                      </div>
                      {showBrandInput && (
                        <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
                          <input
                            type="text"
                            value={newBrand}
                            onChange={(e) => handleNewItemChange(e, setNewBrand, 'Brand')}
                            style={focusedField === 'newBrand' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
                            onFocus={() => setFocusedField('newBrand')}
                            onBlur={() => setFocusedField('')}
                            placeholder="New brand (Alphabets only)"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              handleAddItem('Brand', newBrand, setNewBrand, setShowBrandInput, setBrands, 'brand')
                            }
                            style={styles.addButton}
                          >
                            ✓
                          </button>
                        </div>
                      )}
                    </div>

                    <div style={styles.inputGroup}>
                      <label style={styles.label}>UOM</label>
                      <div style={styles.flexRow}>
                        <select
                          name="unit"
                          value={formData.unit}
                          onChange={handleChange}
                          style={focusedField === 'unit' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
                          onFocus={() => setFocusedField('unit')}
                          onBlur={() => setFocusedField('')}
                        >
                          <option value="">Select Unit</option>
                          {units.map((unit) => (
                            <option key={unit.id} value={unit.name}>
                              {unit.name}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={() => setShowUnitInput(!showUnitInput)}
                          style={styles.addButton}
                        >
                          +
                        </button>
                      </div>
                      {showUnitInput && (
                        <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
                          <input
                            type="text"
                            value={newUnit}
                            onChange={(e) => {
                              const value = e.target.value;
                              setNewUnit(value);
                              setErrorMessage('');
                            }}
                            style={focusedField === 'newUnit' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
                            onFocus={() => setFocusedField('newUnit')}
                            onBlur={() => setFocusedField('')}
                            placeholder="Enter unit"
                          />
                          <button
                            type="button"
                            onClick={() => {
                              handleAddItem('Unit', newUnit, setNewUnit, setShowUnitInput, setUnits, 'unit');
                            }}
                            style={styles.addButton}
                          >
                            ✓
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Style</label>
                    <input
                      type="text"
                      name="style"
                      value={formData.style}
                      onChange={handleChange}
                      style={focusedField === 'style' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                      onFocus={() => setFocusedField('style')}
                      onBlur={() => setFocusedField('')}
                      placeholder="Enter style (Alphabets only)"
                    />
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Label No</label>
                      <input
                        type="text"
                        name="labelNo"
                        value={formData.labelNo}
                        onChange={handleChange}
                        style={focusedField === 'labelNo' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                        onFocus={() => setFocusedField('labelNo')}
                        onBlur={() => setFocusedField('')}
                        placeholder="Enter Label No (Alphabets and Numbers)"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Type</label>
                      <div style={styles.flexRow}>
                        <input
                          type="number"
                          name="type"
                          value={formData.type}
                          onChange={handleChange}
                          style={focusedField === 'type' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
                          onFocus={() => setFocusedField('type')}
                          onBlur={() => setFocusedField('')}
                          placeholder="Enter Type Value"
                          min="0"
                          step="0.01"
                        />
                        <select
                          name="typeMultiplier"
                          value={formData.typeMultiplier}
                          onChange={handleChange}
                          style={focusedField === 'typeMultiplier' ? { ...styles.select, ...styles.selectFocused, width: '80px' } : { ...styles.select, width: '80px' }}
                          onFocus={() => setFocusedField('typeMultiplier')}
                          onBlur={() => setFocusedField('')}
                        >
                          {multiplierOptions.map((option) => (
                            <option key={option} value={option}>
                              ×{option}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Location</label>
                      <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        style={focusedField === 'location' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                        onFocus={() => setFocusedField('location')}
                        onBlur={() => setFocusedField('')}
                        placeholder="Enter Location (Alphabets only)"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Design No</label>
                      <div style={styles.flexRow}>
                        <select
                          name="designNo"
                          value={formData.designNo}
                          onChange={handleChange}
                          style={focusedField === 'designNo' ? { ...styles.select, ...styles.selectFocused, flex: '1' } : { ...styles.select, flex: '1' }}
                          onFocus={() => setFocusedField('designNo')}
                          onBlur={() => setFocusedField('')}
                        >
                          <option value="">Select Design No</option>
                          {designNumbers.map((design) => (
                            <option key={design.id} value={design.designNo}>
                              {design.designNo}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={() => setShowDesignNoInput(!showDesignNoInput)}
                          style={styles.addButton}
                        >
                          +
                        </button>
                      </div>
                      {showDesignNoInput && (
                        <div style={{ ...styles.flexRow, marginTop: '0.5rem' }}>
                          <input
                            type="text"
                            value={newDesignNo}
                            onChange={(e) => handleNewItemChange(e, setNewDesignNo, 'DesignNo')}
                            style={focusedField === 'newDesignNo' ? { ...styles.input, ...styles.inputFocused, flex: '1' } : { ...styles.input, flex: '1' }}
                            onFocus={() => setFocusedField('newDesignNo')}
                            onBlur={() => setFocusedField('')}
                            placeholder="New design number (Alphabets and Numbers)"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              handleAddItem('DesignNo', newDesignNo, setNewDesignNo, setShowDesignNoInput, setDesignNumbers, 'designNo')
                            }
                            style={styles.addButton}
                          >
                            ✓
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div style={styles.section}>
                  <h2 style={styles.sectionHeading}>💰 Price Information</h2>
                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        MRP<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <input
                        type="number"
                        name="mrp"
                        value={formData.mrp}
                        onChange={handleChange}
                        style={focusedField === 'mrp' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                        onFocus={() => setFocusedField('mrp')}
                        onBlur={() => setFocusedField('')}
                        placeholder="0.00"
                        required
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Purchase Rate (Excl. Tax)<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <input
                        type="number"
                        name="purchaseRateExclTax"
                        value={formData.purchaseRateExclTax}
                        onChange={handleChange}
                        style={focusedField === 'purchaseRateExclTax' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                        onFocus={() => setFocusedField('purchaseRateExclTax')}
                        onBlur={() => setFocusedField('')}
                        placeholder="0.00"
                        required
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Selling Rate<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <input
                        type="number"
                        name="sellingRate"
                        value={formData.sellingRate}
                        onChange={handleChange}
                        style={focusedField === 'sellingRate' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                        onFocus={() => setFocusedField('sellingRate')}
                        onBlur={() => setFocusedField('')}
                        placeholder="0.00"
                        required
                        min="0"
                        step="0.01"
                      />
                    </div>
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Margin (%)</label>
                      <input
                        type="text"
                        name="margin"
                        value={formData.margin}
                        style={{ ...styles.input, ...styles.readOnlyInput }}
                        readOnly
                        placeholder="Auto-calculated"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Discount (%)</label>
                      <input
                        type="text"
                        name="discount"
                        value={formData.discount}
                        style={{ ...styles.input, ...styles.readOnlyInput }}
                        readOnly
                        placeholder="Auto-calculated"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Savings (₹)</label>
                      <input
                        type="text"
                        name="savings"
                        value={formData.savings}
                        style={{ ...styles.input, ...styles.readOnlyInput }}
                        readOnly
                        placeholder="Auto-calculated"
                      />
                    </div>
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Purchase Tax (%)<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <select
                        name="purchaseTax"
                        value={formData.purchaseTax}
                        onChange={handleChange}
                        style={focusedField === 'purchaseTax' ? { ...styles.select, ...styles.selectFocused } : styles.select}
                        onFocus={() => setFocusedField('purchaseTax')}
                        onBlur={() => setFocusedField('')}
                        required
                      >
                        <option value="">Select Purchase Tax</option>
                        {taxes.map((tax) => (
                          <option key={tax.id} value={tax.description}>
                            {`${tax.description} (${tax.cgst || tax.sgst || tax.igst || 0}%)`}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Cess Tax (%)</label>
                      <select
                        name="cessTax"
                        value={formData.cessTax}
                        onChange={handleChange}
                        style={focusedField === 'cessTax' ? { ...styles.select, ...styles.selectFocused } : styles.select}
                        onFocus={() => setFocusedField('cessTax')}
                        onBlur={() => setFocusedField('')}
                      >
                        <option value="">Select Cess Tax</option>
                        <option value="0">CESS 0%</option>
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Sales Tax (%)<span style={styles.requiredAsterisk}>*</span>
                      </label>
                      <select
                        name="salesTax"
                        value={formData.salesTax}
                        onChange={handleChange}
                        style={focusedField === 'salesTax' ? { ...styles.select, ...styles.selectFocused } : styles.select}
                        onFocus={() => setFocusedField('salesTax')}
                        onBlur={() => setFocusedField('')}
                        required
                      >
                        <option value="">Select Sales Tax</option>
                        {taxes.map((tax) => (
                          <option key={tax.id} value={tax.description}>
                            {`${tax.description} (${tax.cgst || tax.sgst || tax.igst || 0}%)`}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div style={styles.gridTwoColumns}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Purchase Rate (Incl. Tax)</label>
                      <input
                        type="text"
                        name="costPriceInclTax"
                        value={formData.costPriceInclTax}
                        style={{ ...styles.input, ...styles.readOnlyInput }}
                        readOnly
                        placeholder="Auto-calculated"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Selling Price (Incl. Tax)</label>
                      <input
                        type="text"
                        name="sellingPriceInclTax"
                        value={formData.sellingPriceInclTax}
                        style={{ ...styles.input, ...styles.readOnlyInput }}
                        readOnly
                        placeholder="Auto-calculated"
                      />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Wholesale Rate</label>
                      <input
                        type="number"
                        name="wholesaleRate"
                        value={formData.wholesaleRate}
                        onChange={handleChange}
                        style={focusedField === 'wholesaleRate' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                        onFocus={() => setFocusedField('wholesaleRate')}
                        onBlur={() => setFocusedField('')}
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div style={styles.section}>
                <h2 style={styles.sectionHeading}>📊 Stock Information</h2>
                <div style={styles.gridTwoColumns}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Low Stock Alert</label>
                    <input
                      type="number"
                      name="lowStockAlert"
                      value={formData.lowStockAlert}
                      onChange={handleChange}
                      style={focusedField === 'lowStockAlert' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                      onFocus={() => setFocusedField('lowStockAlert')}
                      onBlur={() => setFocusedField('')}
                      placeholder="0"
                      min="0"
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Re-order Qty</label>
                    <input
                      type="number"
                      name="reorderQty"
                      value={formData.reorderQty}
                      onChange={handleChange}
                      style={focusedField === 'reorderQty' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                      onFocus={() => setFocusedField('reorderQty')}
                      onBlur={() => setFocusedField('')}
                      placeholder="0"
                      min="0"
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Opening Stock</label>
                    <input
                      type="number"
                      name="openingStock"
                      value={formData.openingStock}
                      onChange={handleChange}
                      style={focusedField === 'openingStock' ? { ...styles.input, ...styles.inputFocused } : styles.input}
                      onFocus={() => setFocusedField('openingStock')}
                      onBlur={() => setFocusedField('')}
                      placeholder="0"
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div style={styles.section}>
                <h2 style={styles.sectionHeading}>🖼️ Product Image</h2>
                <div style={styles.imageUploadSection}>
                  <input
                    type="file"
                    id="imageUpload"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setFormData({ ...formData, image: file });
                        setImagePreview(URL.createObjectURL(file));
                      }
                    }}
                    style={styles.fileInput}
                  />
                  <label htmlFor="imageUpload" style={styles.fileInputLabel}>
                    📷 Choose Image
                  </label>
                  <p style={{ marginTop: '0.5rem', color: '#6b7280', fontSize: '0.875rem' }}>
                    Maximum file size: 5MB (JPEG, PNG, GIF)
                  </p>
                  {imagePreview && (
                    <div style={{ marginTop: '1rem' }}>
                      <img src={imagePreview} alt="Preview" style={styles.imagePreview} />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div style={styles.buttonContainer}>
              <button
                type="button"
                onClick={() => {
                  resetForm();
                  onCancel();
                }}
                style={{ ...styles.button, ...styles.cancelButton }}
                disabled={submitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={{ ...styles.button, ...styles.submitButton }}
                disabled={submitting}
              >
                {submitting ? '⏳ Saving...' : editingProduct ? 'Update Product' : 'Add Product'}
              </button>
            </div>
          </form>
        )}
      </div>

      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @media (max-width: 768px) {
          .twoColumnLayout {
            grid-template-columns: 1fr;
          }
          .gridTwoColumns {
            grid-template-columns: 1fr;
          }
          .gridThreeColumns {
            grid-template-columns: 1fr;
          }
          .buttonContainer {
            flex-direction: column;
          }
          .button {
            width: 100%;
            justify-content: center;
          }
        }
        button:hover:not(:disabled) {
          filter: brightness(90%);
        }
      `}</style>
    </div>
  );
};

export default ProductForm;